module.exports = __webpack_public_path__ + "assets/img/r5.fcf2928d.png";